import { FormErrors } from "redux-form";

import {
    required,
    validEmail,
    isNumeric,
    lessThanOrEqual,
    numberBetween,
} from "../../../util/validators";
import { NewThreadFormData } from "views/messages/components/NewThreadForm";

const validateNewThreadForm = (values: NewThreadFormData) => {
    const errors: FormErrors<NewThreadFormData> = {};

    errors.body = required(values.body);
    if (!errors.body) {
        errors.body =
            values.body.trim().length === 0 ? "Pakollinen" : undefined;
    }

    errors.subject = required(values.subject);
    if (!errors.subject) {
        errors.subject =
            values.subject.trim().length === 0 ? "Pakollinen" : undefined;
    }

    errors.subjectCategoryId = required(values.subjectCategoryId);

    return errors;
};

export default validateNewThreadForm;



// WEBPACK FOOTER //
// ./src/views/messages/components/NewThreadFormValidator.tsx